<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.contactClsManagement") }}</h4>
    </div>
    <div class="commTop_btn_wrap p-2" style="text-align: right">
      <router-link
        to="/management/support/contact/cls/form"
        class="btn btn-primary btn-md m-2"
        >{{ $t("common.add") }}</router-link
      >
      <button type="button" @click="showContactModal" class="btn btn-secondary btn-md">
        {{ $t("common.changeOrder") }}
      </button>
    </div>

    <table class="list_tbl">
      <thead>
        <tr>
          <th class="mobile_row">{{ $t("common.ClassificationName") }}</th>
          <th class="mobile_h">{{ $t("common.clsDetail") }}</th>
          <th class="mobile_h">{{ $t("common.date") }}</th>
          <th class="mobile_h">{{ $t("common.writer") }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody v-if="clsList.length != 0">
        <tr v-for="(cls, index) in clsList" :key="index">
          <td class="text-left">
            <router-link
              :to="{ name: 'mgmtContactClsForm', params: { classId: cls.classId } }"
              >{{ cls.className }}</router-link
            >
          </td>
          <td>
            <router-link
              :to="{ name: 'mgmtContactClsForm', params: { classId: cls.classId } }"
              >{{ cls.classDesc }}</router-link
            >
          </td>
          <td>
            <router-link
              :to="{ name: 'mgmtContactClsForm', params: { classId: cls.classId } }"
              >{{ cls.firstRegDatetime }}</router-link
            >
          </td>
          <td>
            <router-link
              :to="{ name: 'mgmtContactClsForm', params: { classId: cls.classId } }"
              >{{ cls.userName }}</router-link
            >
          </td>
          <td>
            <button
              type="button"
              @click="deleteContactCls(cls.classId)"
              class="btn btn-secondary btn-sm"
            >
              {{ $t("common.delete") }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <CommonModal id="contactClsModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("common.changeOrder") }}</h3>
      </template>
      <template slot="body">
        <table class="list_tbl">
          <thead>
            <tr>
              <th class="mobile_row w-25">{{ $t("common.ClassificationName") }}</th>
              <th class="mobile_h w-25">{{ $t("common.description") }}</th>
              <th class="mobile_h w-25">{{ $t("common.writer") }}</th>
              <th class="mobile_h w-25">{{ $t("common.date") }}</th>
            </tr>
          </thead>
          <draggable v-model="clsList" tag="tbody">
            <tr v-for="cls in clsList" :key="cls.classId">
              <td class="w-25">{{ cls.className }}</td>
              <td class="w-25">{{ cls.classDesc }}</td>
              <td class="w-25">{{ cls.lastModrName }}</td>
              <td class="w-25">{{ cls.userName }}</td>
            </tr>
          </draggable>
        </table>
      </template>
      <template slot="footer">
        <button type="button" @click="saveNewSort" class="btn btn-primary">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import {
  getContactClsList,
  saveNewContactClsSort,
  deleteContactCls,
} from "@/api/contact";
import CommonModal from "@/components/modal/CommonModal";
import draggable from "vuedraggable";
export default {
  components: {
    CommonModal,
    draggable,
  },
  data() {
    return {
      clsList: [],
      confirmYN: false,
      cls: { classId: "" },
      showModal: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await getContactClsList();
        this.clsList = data.clsList;
      } catch (error) {
        console.log(error);
      }
    },
    showContactModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    checkMove() {},
    // 새로운 순서 저장
    async saveNewSort() {
      this.conformYN = confirm(this.$t("alert.save"));
      if (this.conformYN) {
        try {
          const { data } = await saveNewContactClsSort(this.clsList);
          if (data.status) {
            alert(this.$t("alert.changedSuccessfully"));
            this.showModal = false;
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
    async deleteContactCls(classId) {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          this.cls.classId = classId;
          const { data } = await deleteContactCls(this.cls);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.fetchData();
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style></style>
